const object = {
    user: {},
    device: {},
    pagination: {
        isGoBack: false,
        academicYear: '110',
        academicSemester: '1',
        current: 1,
        pageSize: 5,
        columnSort: '',
        orderBy: '',
        searchField: '',
        searchValue: '',
        filterStatus: '',
    },
}
export default object